import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyMobileBar from "@/components/StickyMobileBar";
import HomePage from "@/pages/HomePage";
import ContentPage from "@/pages/ContentPage";
import ContactPage from "@/pages/ContactPage";
import CaregiverPackagesPage from "@/pages/CaregiverPackagesPage";
import NotFoundPage from "@/pages/NotFoundPage";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <div className="min-h-screen bg-brand-cream font-body text-brand-charcoal pb-16 md:pb-0">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/categories/:slug" element={<ContentPage />} />
          <Route path="/services/:slug" element={<ContentPage />} />
          <Route path="/pricing-guide" element={<ContentPage slug="pricing-guide" />} />
          <Route path="/how-to-choose-a-nursing-home" element={<ContentPage slug="how-to-choose-a-nursing-home" />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/caregiver-packages" element={<CaregiverPackagesPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
        <StickyMobileBar />
      </div>
    </BrowserRouter>
  );
}

export default App;
